import { useMutation } from "@apollo/client";
import { useCallback, useState } from "react";
import {
  SaveAssessmentMutation,
  SaveAssessmentMutationVariables,
} from "types/graphql-schema";

import { currentOrganizationVar } from "@cache/cache";
import { useLink } from "@components/link/link-helpers";

import createOrUpdateAssessmentMutation from "../graphql/create-or-update-assessment-mutation";

const useCreateEmptyAssessment = (previousPathname: string) => {
  const link = useLink();
  const organization = currentOrganizationVar();

  const [saveAssessment] = useMutation<
    SaveAssessmentMutation,
    SaveAssessmentMutationVariables
  >(createOrUpdateAssessmentMutation);
  const [isLoading, setIsLoading] = useState(false);

  const handleCreateEmptyAssessment = useCallback(
    (
      complianceProgramId: number,
      assessmentTemplateId: number,
      targetId: number | undefined,
      path: "/assessments" | "/survey" = "/assessments",
    ) => {
      setIsLoading(true);
      saveAssessment({
        variables: {
          targetId,
          assessmentTemplateId,
          complianceProgramId,
          organizationId: organization.id,
        },
        onCompleted: (response) => {
          setIsLoading(false);
          link.redirect({
            pathname: `${path}/assessment/${response.createOrUpdateAssessment.assessment.id}`,
            state: {
              previousPathname,
            },
          });
        },
        // A failed create must not leave the caller stuck on "Creating...".
        onError: () => setIsLoading(false),
      });
    },
    [link, organization, previousPathname, saveAssessment],
  );

  return { handleCreateEmptyAssessment, isLoading };
};

export default useCreateEmptyAssessment;
